/* NSH v6 — 이미지 제거 + 텍스트 공유 + 즉시 카피. engine-2.js 뒤에 로드. */

/* ================= 즉시 카피 (2026-08-26 · 08-27 확장) =================
   notes 글처럼 첫 화면부터 제 언어로, 그리고 이후 움직임 없이.
   이 파일은 템플릿이 asset_url(버전 토큰)로 부르므로 항상 최신이고,
   HTML 파싱 직후 동기 실행된다 — 패치 체인(1~3초)을 기다리지 않는다.
   ① 인트로·공유CTA 를 현재 로케일로 즉시 칠하고 data-v7g="5" 를 심는다.
   ② 좌측 패널 태그라인도 즉시 확정(data-v7n="2") — v7n 이 1~3초 뒤 바꾸던 것.
   ③ __STATIC 에서 이 영역 제거 → 엔진·v7g 재도장 원천 차단.
   ④ 템플릿의 중복 폰트 링크(display=swap)를 제거 — 스니펫의 optional 링크만 남긴다.
      (같은 서체를 swap 으로 한 번 더 부르면 뒤 규칙이 이겨 글자 출렁임이 되살아난다)
   ⑤ 칠한 직후 data-nsh-copy 로 가림막을 걷는다.
   ⚠ 한글·일본어는 원문 그대로. 올린 뒤 반드시 되읽어 확인.
   10-21(v13.14): 첫 화면 = 첫 질문. #intro 에 h1·.sub·.disclaimer 가 없어져 표 C 에서 세 키를 뺐다(btn-bar 는 첫 화면 맨 위 작은 줄로 남아 같은 문구).
     patch9-v7x·v8i6 의 같은 키는 칠할 대상이 없어 아무 일도 하지 않는다(파일은 그대로 — 이름을 바꿔 다시 올릴 필요 없음).
   10-07(v13.2): KO 인트로 문구 교체(나은 확정안), JA 인트로 버튼 「60秒肌診断」·sub 끝 「60秒です。」 삭제. v8i→v8i3, patch2-v7x→patch4-v7x 로 이름을 바꿔 부른다(CDN 경로 캐시). */
(function () {
  try {
    var loc = "en";
    try {
      if (typeof __LOC !== "undefined" && __LOC) loc = String(__LOC);
      else if (/^\/ja(\/|$)/.test(location.pathname)) loc = "ja";
      else if (/^\/ko(\/|$)/.test(location.pathname)) loc = "ko";
    } catch (e) { }

    var C = {
      ko: {
        "#intro .btn-bar": "60초 피부 읽기",
        "#sharedCta .formula-h": "당신의 피부는요?",
        "#sharedCta .formula-copy": "좋은 피부는 이미 내 안에 있습니다. 오늘 내 피부에 어울리는 제품과 쓰지 말아야 할 제품, 그리고 관리법을 알려드릴게요.",
        "#sharedCta .btn-bar": "60초 피부 읽기",
        "#sharedCta .meta": "17개 문항 · 60초 소요",
        ".cta-float-q": "당신의 피부는요?",
        ".cta-float-btn": "60초 피부 읽기"
      },
      en: {
        "#intro .btn-bar": "Read my skin · 60 seconds",
        "#sharedCta .formula-h": "How about your skin?",
        "#sharedCta .formula-copy": "Your best skin was always yours. We'll show you what suits your skin today, what to stop using, and how to care for it.",
        "#sharedCta .btn-bar": "Read my skin · 60 seconds",
        "#sharedCta .meta": "17 questions · 60 seconds",
        ".cta-float-q": "How about your skin?",
        ".cta-float-btn": "Read my skin · 60 seconds"
      },
      ja: {
        "#intro .btn-bar": "60秒肌診断",
        "#sharedCta .formula-h": "あなたの肌は？",
        "#sharedCta .formula-copy": "いちばんいい肌は、すでに自分の中にあります。今日の肌に合うもの、使わないほうがいいもの、そしてケアの方法をお伝えします。",
        "#sharedCta .btn-bar": "60秒肌診断",
        "#sharedCta .meta": "17の質問 · 60秒",
        ".cta-float-q": "あなたの肌は？",
        ".cta-float-btn": "60秒肌診断"
      }
    };
    /* v13.26 (cta1): tab title = snippets/nsh-quiz-copy title. Older patches (v7g3 ko/en, v7o / v7p, patch8-v7x ja) still assign
       document.title; the setter below keeps the snippet value, so the tab never flips (patch8-v7x re-locks /ja to the same text). */
    try {
      var TT = {"ko": "오늘 내 피부 읽기 · nooy suhsuh", "en": "Read your skin · nooy suhsuh", "ja": "今日の肌を読む · nooy suhsuh"};
      var tt = TT[loc] || TT.en, td = Object.getOwnPropertyDescriptor(Document.prototype, "title");
      if (td && td.set && td.get) {
        var tforce = function () { try { if (td.get.call(document) !== tt) td.set.call(document, tt); } catch (e) { } };
        Object.defineProperty(document, "title", { configurable: true, get: function () { return td.get.call(document); }, set: function () { tforce(); } });
        tforce();
      }
    } catch (e) { }

    var map = C[loc] || C.en;
    for (var sel in map) {
      if (!Object.prototype.hasOwnProperty.call(map, sel)) continue;
      var el = document.querySelector(sel);
      if (!el) continue;
      if (el.innerHTML !== map[sel]) el.innerHTML = map[sel];
      el.setAttribute("data-v7g", "5");
    }

    /* ② 좌측 태그라인 — v7n 이 늦게 바꾸던 문구를 즉시 확정 (전 로케일 공통) */
    try {
      var tg = document.querySelector(".media-tagline");
      if (tg) {
        var TGL = "Your optimum isn’t a destination.<br>It’s the pace your skin was born with.";
        if (tg.innerHTML !== TGL) tg.innerHTML = TGL;
        tg.removeAttribute("style");
        tg.setAttribute("data-v7n", "2");
      }
    } catch (e) { }

    /* ④ 템플릿의 중복 폰트 링크(swap) 제거 — 스니펫의 optional 링크만 남는다 */
    try {
      [].slice.call(document.querySelectorAll('link[href*="fonts.googleapis"]')).forEach(function (l) {
        var h = l.getAttribute("href") || "";
        if (h.indexOf("display=swap") >= 0 && h.indexOf("Instrument+Serif") >= 0) l.remove();
      });
    } catch (e) { }

    /* ③ 엔진·v7g 의 정적 재도장에서 이 영역을 뺀다 */
    try {
      if (typeof __STATIC !== "undefined" && __STATIC.length) {
        for (var i = __STATIC.length - 1; i >= 0; i--) {
          var s0 = String(__STATIC[i][0] || "");
          if (s0.indexOf("#intro") === 0 || s0.indexOf("#sharedCta") === 0 || s0.indexOf(".cta-float") === 0) {
            __STATIC.splice(i, 1);
          }
        }
      }
    } catch (e) { }

    document.documentElement.setAttribute("data-nsh-copy", "1");
  } catch (e) {
    try { document.documentElement.setAttribute("data-nsh-copy", "1"); } catch (e2) { }
  }
})();

var NSH_BLANK_PX = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

function imgUrl(n) { return NSH_BLANK_PX; }

(function () {
  try {
    var s = document.createElement("style");
    s.textContent = ".veil-img,.veil-tint{display:none!important}"
      + "#result .type-figure,#result #stateImg{display:none!important}";
    document.head.appendChild(s);
  } catch (e) { }
})();

(function () {
  try {
    ["mediaA", "mediaB", "stateImg", "veilImg"].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.getAttribute("src")) el.setAttribute("src", NSH_BLANK_PX);
    });
  } catch (e) { }
})();

function shareText() {
  var d = window.__cardData || {};
  if (typeof __LOC !== "undefined" && __LOC === "ja")
    return (d.stateName ? "今日の私の肌は「" + d.stateName + "」だそうです。" : "") + "あなたの肌は今日どうですか？";
  if (typeof __LOC !== "undefined" && __LOC !== "ko")
    return (d.stateName ? "My skin today: '" + d.stateName + "'. " : "") + "How is yours today?";
  return (d.stateName ? "오늘 제 피부는 '" + d.stateName + "'래요. " : "") + "당신의 피부는 오늘 어떤가요?";
}

function __nshFlash(msg) {
  try {
    var b = document.querySelector("#shareWrap .btn-bar");
    if (!b || b.dataset.busy) return;
    var was = b.textContent;
    b.dataset.busy = "1"; b.textContent = msg;
    setTimeout(function () { b.textContent = was; delete b.dataset.busy; }, 1800);
  } catch (e) { }
}

function shareResult() {
  var text = shareText(), url = shareUrl(), full = text + " " + url;
  var JA = (typeof __LOC !== "undefined" && __LOC === "ja");
  var NOTKO = (typeof __LOC !== "undefined" && __LOC !== "ko");
  logEvent("share_click", { card: false });
  try {
    if (navigator.share) {
      navigator.share({ title: JA ? "今日の肌を読む" : (NOTKO ? "Your skin, read today" : "오늘 내 피부 읽기"), text: text, url: url })
        .catch(function () { });
      return;
    }
  } catch (e) { }
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(full).then(
        function () { __nshFlash(JA ? "リンクをコピーしました" : (NOTKO ? "Link copied" : "링크를 복사했어요")); },
        function () { window.prompt(JA ? "このリンクをコピーしてください" : (NOTKO ? "Copy this link" : "이 링크를 복사하세요"), full); }
      );
      return;
    }
  } catch (e) { }
  window.prompt(JA ? "このリンクをコピーしてください" : (NOTKO ? "Copy this link" : "이 링크를 복사하세요"), full);
}

/* ================= 로더 =================
   운영 규칙은 직전 버전 주석과 동일(1~11 + 즉시카피). 새 패치는 반드시 v8j 앞에.
   v8n2 — 제품 추천 축소 (슬롯당 1개, hydrate 제품 제거).
   v8o  — 과소×장벽손상 모순 문단 교체. 둘 다 데이터만 건드리므로 ja 패치 뒤.
   ※ v8n → v8n2 로 이름을 바꿔 붙였다. CDN 이 경로로 캐싱해서
     같은 이름으로 다시 올리면 수정본이 안 나간다. 재발생 주의. */
/* 10-11 (v13.23): patch-v7g -> patch-v7g2 (copy-refresh idempotent), patch5-v7x -> patch6-v7x (digit-glyph aware), v8i3 -> v8i4 (digit-glyph aware);
   intro disclaimer without <br> in all locales (v10b turned it into a space after first paint = a visible reflow), same text as snippets/nsh-quiz-copy.
   10-11 (v13.7): patch4-v7x -> patch5-v7x (same file + setHTML guard that ends the /ja
   intro jitter). Renamed because the CDN serves unversioned paths from cache (max-age 1y). */
/* 10-12 (v13.26 cta1): copy table C is generated from snippets/nsh-quiz-copy (all ten keys, all three locales, character for character);
   tab title locked to the snippet title; patch7-v7x -> patch8-v7x and v8i4 -> v8i5 (same scripts, new copy; renamed for the CDN path cache). */
/* 10-16 (v13.28): patch8-v7x -> patch9-v7x and v8i5 -> v8i6 (same files, new intro sub line; renamed for the CDN path cache). */
/* 10-11 (v13.23b): patch-v7e still chains the old patch-v7g.js (not idempotent: Korean intro/gate copy first, then a repaint) - drop that one
   script; patch-v7g2 above carries the same copy. patch6-v7x -> patch7-v7x (syncs its Japanese into __STATIC so patch-v7h stops repainting English); patch-v7g2 -> patch-v7g3 (no EN into __STATIC on /ja). */
(function(){try{var h=document.head,ap=h.appendChild;if(h.__nshNoV7g)return;h.__nshNoV7g=1;h.appendChild=function(n){try{if(n&&n.tagName==="SCRIPT"&&/nsh-quiz-patch-v7g\.js/.test(n.src||"")){window.__nshV7gSkipped=(window.__nshV7gSkipped||0)+1;return n;}}catch(e){}return ap.apply(this,arguments);};}catch(e){}})();
(function () {
  try {
    var me = document.currentScript || document.querySelector('script[src*="nsh-quiz-card-v6"]');
    if (!me || !me.src) return;
    var base = me.src.split("?")[0].replace("nsh-quiz-card-v6.js", "");
    function load(name) {
      var s = document.createElement("script");
      s.src = base + name + ".js";
      s.async = false;
      document.head.appendChild(s);
    }
    ["patch-v7","patch-v7b","patch-v7c","patch-v7d","patch-v7e","patch-v7f","patch-v7g3","patch-v7h","patch-v7i","patch-v7j","patch-v7k","patch-v7l","patch-v7m","patch-v7n","patch-v7o","patch-v7p","patch-v7v","patch9-v7x","patch-v7w"]
      .forEach(function (n) { load("nsh-quiz-" + n); });
    load("nsh-quiz-en-fix");
    ["ja-core","ja-read1","ja-read2","ja-sig1","ja-sig2","ja-fix","ja-fix2",
     "ja-gauge","ja-gauge2","ja-slot1","ja-slot2","ja-slot3","ja-slot4",
     "ja-frag1","ja-frag2","ja-prod1","ja-prod2","ja-cut","ja-own","ja-rest","ja-cmt",
     "ja-dom","ja-dom2","ja-num","ja-fix4"]
      .forEach(function (n) { load("nsh-quiz-" + n); });
    load("nsh-quiz-share-fix");
    load("nsh-quiz-v8f");
    load("nsh-quiz-v8b2");
    load("nsh-quiz-v8c");
    load("nsh-quiz-v8g");
    load("nsh-quiz-v8h");
    load("nsh-quiz-v8i6");
    load("nsh-quiz-v8n2");
    load("nsh-quiz-v8o");
    load("nsh-quiz-v8j");
  } catch (e) { }
})();
